import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { LojistikIrsaliye } from 'src/model/lojistik-irsaliye';
import { LojistikFaturaKaydetRequest } from 'src/model/LojistikFaturaKaydetRequest';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-lojistik-irsaliye-liste',
  templateUrl: './lojistik-irsaliye-liste.component.html',
  styleUrls: ['./lojistik-irsaliye-liste.component.css']
})
export class LojistikIrsaliyeListeComponent implements OnInit {

  irsaliyeler: LojistikIrsaliye[] = null;
  eklenenIrsaliyeler: LojistikIrsaliye[] = [];
  basTarBitTar: string[] = [];
  irsaliyeList: any;

  satinAlmaButtons: Boolean;
  faturalandirilacakIrsaliyeler = [];

  faturalandirFirstStep: boolean = false;
  faturaAdi: string;

  distinctFaturaName: any;

  secilenIrsaliyeList: Array<any> = new Array<any>();
  secilenleriKaldirilacaklar: Array<any> = new Array<any>();
  baslangicTarih: Date;
  bitisTarihi: Date;
  firstIrsaliyeList: any;
  mazotBazFiyat:number;

  toplamTutar:number = 0;

  ctrlIrsaliyeDuzenle:boolean=false;
  irsaliyeDuzenle:any;

  @Output() irsaliyeDetay = new EventEmitter<LojistikIrsaliye>();

  @Input()
  public set source(irsaliyeler: LojistikIrsaliye[]) {
    if (irsaliyeler != null) {
      this.irsaliyeler = irsaliyeler;
    }
  }
  @Input()
  public set source2(basTarBitTar: string[]) {
    if (basTarBitTar != null) {
      this.basTarBitTar = basTarBitTar;
    }
  }

  @Input()
  public set lojistikIrsaliyeList(listData: any) {
    if (listData.lojistikIrsaliyeList != null) {
      this.firstIrsaliyeList = listData.lojistikIrsaliyeList;
    }
    this.satinAlmaButtons = listData.permission;
    if (!this.satinAlmaButtons) {
      this.irsaliyeList = listData.lojistikIrsaliyeList;
      this.faturaDistinct()
    } else {
      this.mazotBazFiyat = listData.mazotBazFiyati;
    }
  }

  constructor(private toastrService: ToastrService,
    private restService: RestService) { }

  ngOnInit() {
    
  }

  isDonus(irsaliye:any){
    console.log('irsaliye', irsaliye);
  }

  ekle(i: any) {
    let ctrl = this.faturalandirilacakIrsaliyeler.findIndex(x => x.lojistik.irsaliyeNo === i.lojistik.irsaliyeNo && x.lojistik.cariKod === i.lojistik.cariKod) != -1;
    if (ctrl) {
      this.toastrService.warning("İrsaliye daha önce eklenmiş!", "Uyarı!");
      return;
    }
    this.faturalandirilacakIrsaliyeler.push(i);
  }

  kaldir(index: any) {
    this.faturalandirilacakIrsaliyeler.splice(index, 1);
  }

  detay(i: LojistikIrsaliye) {
    this.irsaliyeDetay.emit(i);
  }

  // faturalandir() {
  //   let splittedBasTar = this.basTarBitTar[0].split('.');
  //   let splittedBitTar = this.basTarBitTar[1].split('.');

  //   const request = new LojistikFaturaKaydetRequest();
  //   request.basTar = new Date(splittedBasTar[2] + '-' + splittedBasTar[1] + '-' + splittedBasTar[0]);
  //   request.bitTar = new Date(splittedBitTar[2] + '-' + splittedBitTar[1] + '-' + splittedBitTar[0]);
  //   request.tasiyiciVkn = this.eklenenIrsaliyeler[0].tasiyiciVkn;

  //   request.lojistikFaturaDetaylar = this.eklenenIrsaliyeler;
  //   this.restService.lojistikFaturaKaydet(request).subscribe(res => {
  //     this.irsaliyeler = [];
  //     this.eklenenIrsaliyeler = [];
  //   });
  // }

  faturalandirFirst() {
    let irsaliyeList = [];
    this.faturalandirilacakIrsaliyeler.forEach(element => {
      let bas = (moment(this.baslangicTarih)).format('MM.DD.YYYY');
      let bit = (moment(this.bitisTarihi)).format('MM.DD.YYYY');
      element.lojistik["id"] = 0;
      element.lojistik["name"] = bas + " - " + bit+ " İrsaliyeleri - " + element.lojistik.tasimaciVkn.substr(0,3) + element.lojistik.tasimaciVkn.substr(element.lojistik.tasimaciVkn.length-3);
      element.lojistik["birimFiyat"] = this.gercekFiyat(element.lojistik.donus ? element.birimFiyat?.doluDoluFiyat :  element.birimFiyat?.bosDoluFiyat, element.aktifMazotFiyat);
      element.lojistik["toplamFiyat"] = this.customParseFloat(element.lojistik.donus ? element.birimFiyat?.doluDoluFiyat :  element.birimFiyat?.bosDoluFiyat , element.aktifMazotFiyat, element.lojistik.miktar, element.lojistik.customMiktar)  
      irsaliyeList.push(element.lojistik);
    });
    console.log(irsaliyeList)
    this.restService.tasimaciSaveIrsaliye(irsaliyeList).subscribe(res => {
      console.log('restService.tasimaciSaveIrsaliye', res);
      this.faturalandirFirstStep = false;
    })
  }
  faturalandirLast(){}
  // faturalandirLast() {
  //   let irsaliyeList = [];
  //   this.faturalandirilacakIrsaliyeler.forEach(element => {
  //     element.lojistik["name"] = this.faturaAdi;
  //     element.lojistik["birimFiyat"] = element.birimFiyat;
  //     irsaliyeList.push(element.lojistik);
  //   });
  //   this.restService.tasimaciSaveIrsaliye(irsaliyeList).subscribe(res => {
  //     console.log('restService.tasimaciSaveIrsaliye', res);
  //     this.faturalandirFirstStep = false;
  //   })
  // }

  customParseFloat(biriFiyat:number, aktifMazot:number, miktar:number, customMiktar:number) {
    let calc = (aktifMazot*100) / this.mazotBazFiyat;
    let result = (biriFiyat*calc) / 100;
    let cMiktar = 0;
    if(customMiktar != null && customMiktar > 0){
      cMiktar = customMiktar;
    }else{
      cMiktar = miktar;
    }

    return (result*cMiktar).toFixed(2);
  }

  type(data){
    return typeof data 
  }

  customParseFloatA(t){
    this.toplamTutar = this.toplamTutar + parseFloat(parseFloat(t).toFixed(2));
    return parseFloat(t).toFixed(2);
  }


  faturaDistinct() {
    this.distinctFaturaName = [...new Set(this.irsaliyeList.map(item => item.name))];
  }


  onSaveCheckboxChange(irsaliye: any) {
    let ctrl = this.secilenIrsaliyeList.indexOf(irsaliye, 0);
    if (ctrl > -1) {
      this.secilenIrsaliyeList.splice(ctrl, 1);
    } else {
      this.secilenIrsaliyeList.push(irsaliye)
    }
  }

  addRange() {
    this.secilenIrsaliyeList.forEach(elem => {
      this.ekle(elem);
    })
  }

  onRemoveCheckboxChange(irsaliye) {
    let ctrl = this.secilenleriKaldirilacaklar.indexOf(irsaliye, 0);
    if (ctrl > -1) {
      this.secilenleriKaldirilacaklar.splice(ctrl, 1);
    } else {
      this.secilenleriKaldirilacaklar.push(irsaliye)
    }
  }

  removeRange() {
    let range =this.secilenleriKaldirilacaklar; 
    range.forEach(elem => {
      this.removeIrsaliye(elem)
    });
  }

  removeIrsaliye(irsaliye: any) {
    let thisElem = this.secilenleriKaldirilacaklar.indexOf(irsaliye, 0);
    let ctrl = this.faturalandirilacakIrsaliyeler.indexOf(irsaliye, 0);
    if (ctrl > -1) {
      this.faturalandirilacakIrsaliyeler.splice(ctrl, 1);
      this.secilenleriKaldirilacaklar.splice(thisElem, 1);
    }
  }

  dateChange() {
    this.irsaliyeList = this.firstIrsaliyeList.filter(f => this.baslangicTarih < new Date(f.lojistik.irsaliyeTarih) && this.bitisTarihi > new Date(f.lojistik.irsaliyeTarih));
  }

  /**
   * 
   * @param fiyat Birim Fiyat
   * @param aktifFiyat AktifMozotFiyat
   * @returns Tutar
   */
  gercekFiyat(fiyat:number, aktifFiyat:number){
    let fixedAktif = aktifFiyat.toFixed(2);
    let result = 0;    
    let calc = ((parseFloat(fixedAktif)*100) / this.mazotBazFiyat) - 100;
    if(Math.abs(calc) >= 5){
      result = fiyat + (fiyat * ((calc / 100)*0.45));
    }
    else{
      result = fiyat;
    }
    return result.toFixed(2);
  }

  toplamTutarParse(t:any){
    return t.reduce((partialSum, a) => partialSum + (a.toplamFiyat), 0).toFixed(2);
  }

  editMiktar(i:any){
    this.ctrlIrsaliyeDuzenle=true;
    this.irsaliyeDuzenle = new Object(i);
  }

  miktarSave(){
    this.ctrlIrsaliyeDuzenle=false;
    this.irsaliyeList.find(x => x.lojistik.id == this.irsaliyeDuzenle.lojistik.id).lojistik.customMiktar = this.irsaliyeDuzenle.lojistik.customMiktar;
    debugger;
  }

  senkronIrsaliye(){
    this.restService.senkronIrsaliye().subscribe(res => {
      this.toastrService.show("İrsaliye listesi yenilenmiştir. Sayfayı yenileyiniz.")
    });
  }

}


